import dayjs from 'dayjs';
import constants, { encryptedMarketplaceId } from '@/constants';
import { i18n } from '@/local/index';
import { getAppConfig } from '@/utils/common';
export const apiType = {
  createPurchase: 'create',
  setDeliveryAddr: 'getAddress'
};

const dayFormat = `M${i18n.global.t('common.month')}D${i18n.global.t(
  'common.day'
)}`;
export const handlePromiseTime = delivery => {
  if (delivery?.promiseEndTime && delivery?.promiseStartTime) {
    const startTime = dayjs(delivery?.promiseStartTime * 1000).format(
      dayFormat
    );
    const endTime = dayjs(delivery?.promiseEndTime * 1000).format(dayFormat);
    const promiseDateRange =
      startTime === endTime ? startTime : `${startTime} - ${endTime}`;
    return `${
      i18n.global.t('modules.checkout.EXPECTED') + promiseDateRange
    } ${i18n.global.t('modules.checkout.DELIVERYDATE')}`;
  }
  return i18n.global.t('modules.checkout.PROMISE_DATE_UNKWON');
};
function isFreeshippingPromotion(promotion) {
  return constants.FREE_SHIPPING_PROMOTION.some(i => {
    return promotion.shortMerchandisingMessage.indexOf(i) !== -1;
  });
}
export const priceCalc = orderDetailList => {
  let total = 0; // Total amount
  let importFee = 0;
  let shippingFee = 0;
  let shippingDiscount = 0;
  let discount = 0;
  const promotionList = new Map();
  let shippingPromotion = null;
  const list = [];
  orderDetailList?.forEach(orderItem => {
    orderItem.itemList.forEach(asinItem => {
      list.push({
        asin: asinItem.asin,
        price: asinItem.asinDetail.ourPrice.amount,
        quantity: asinItem.quantity,
        ...(asinItem.promiseDetail.promiseStartTime > 0 && {
          promiseTime: handlePromiseTime(asinItem.promiseDetail)
        })
      });
    });
    total += orderItem.totalAmount.value;
    importFee += orderItem.importFee.value;
    shippingFee += orderItem.shippingFee.value;
    shippingDiscount += orderItem.shippingDiscount.value;
    discount += orderItem.discount.value;
    orderItem?.orderUsedPromotionModelList?.forEach(promotion => {
      if (!promotionList.has(promotion.encryptedPromotionId)) {
        if (isFreeshippingPromotion(promotion)) {
          shippingPromotion = promotion;
        } else {
          promotionList.set(promotion.encryptedPromotionId, promotion);
        }
      }
    });
  });

  return {
    list,
    allPrice: {
      shippingFee,
      shippingDiscount,
      importFee,
      total,
      discount,
      promotionList,
      shippingPromotion
    }
  };
};

export function handleAsin(checkoutItem) {
  return {
    gsBadge: constants.MERCHANT_BADGE_MAP[checkoutItem.productItem.merchantId],
    imageUrl: checkoutItem.productItem.mainImage,
    title: checkoutItem.productItem.title,
    specificationText:
      checkoutItem?.productItem?.specificationText ||
      checkoutItem.productItem?.twisterDisplayString,
    nonReturnableFlag: checkoutItem.productItem.nonReturnableFlag,
    maxOrderQuantity: checkoutItem.productItem.maxOrderQuantity,
    minOrderQuantity: checkoutItem.productItem.minOrderQuantity,
    stocks:
      checkoutItem.productItem.stockOnHand || checkoutItem.productItem.stocks,
    isGlobalStoreFreeShippingProgram:
      checkoutItem.productItem?.delivery?.isGlobalStoreFreeShippingProgram,
    isGlobalStorePrimeOffer:
      checkoutItem.productItem?.delivery?.isGlobalStorePrimeOffer,
    dealOffer: checkoutItem.productItem?.dealOffer ?? null,
    ...(checkoutItem.associatesInfo && {
      associatesInfo: checkoutItem.associatesInfo
    })
  };
}
export const generateAsinDetail = (pricelist, checkoutItemList) => {
  let importFee = 0;
  let nonReturnable = false;
  pricelist.forEach((priceitem, priceindex, priceArr) => {
    checkoutItemList?.forEach(checkoutItem => {
      if (priceitem.asin === checkoutItem.productItem.asin) {
        priceArr[priceindex] = Object.assign(
          {},
          priceitem,
          handleAsin(checkoutItem)
        );
        if (
          checkoutItem.productItem.nonReturnableFlag ===
          constants.NON_RETURNABLE_FLAG.FALSE
        ) {
          nonReturnable = true;
        }

        importFee +=
          checkoutItem.productItem?.globalStore?.importFee?.amount *
          checkoutItem.count;
      }
    });
  });
  return {
    pricelist,
    importFee,
    nonReturnable
  };
};

function uniqueArray(arr) {
  const res = new Set();
  return arr.filter(a => !res.has(a) && res.add(a, 1));
}
export function groupAsinsFromPromiseRange(arr, key) {
  const allGroupName = arr.map(item => {
    return item[key];
  });
  const typeList = uniqueArray(allGroupName);
  const list = [];

  typeList.forEach(typeItem => {
    const obj = {};
    obj.shoppedItemList = [];
    obj.shoppedItemList = arr.filter(item => typeItem === item[key]);
    obj.promiseTime = typeItem;
    obj.key = Date.now();
    list.push(obj);
  });

  return list;
}
export const filterAndResortKnownCVs = cvList => {
  const cvPriortyList = [];
  cvList.forEach(cvItem => {
    if (cvItem && cvItem.reason) {
      const cvPriority = constants.CV_SIGN_PRIORITY_MAP.get(cvItem.reason);
      if (cvPriority) {
        cvPriortyList.push({
          cvItem,
          priority: cvPriority
        });
      }
    }
  });
  if (!cvPriortyList || cvPriortyList.length === 0) {
    return null;
  }
  cvPriortyList.sort((a, b) => {
    return b.priority - a.priority;
  });
  return cvPriortyList.filter(item => {
    return item.cvItem;
  });
};
export const errorTypes = {
  PARTIAL_OUT_OF_STOCK: 'partialOutOfStock',
  ALL_OUT_OF_STOCK: 'allOutOfStock',
  INVALID_COUPON: 'invalidCoupon',
  QUANTITY_LIMIT: 'quantityLimit',
  UNKNOWN_FAIL: 'unknownFail',
  UNINSTALL_WECHAT: 'uninstallWechat',
  NOT_PLACE_ORDER: 'notPlaceOrder'
};

export const errorHandle = {
  partialOutOfStock: {
    popTitle: i18n.global.t('modules.checkout.PRODUCTS_HAVE_BEEN_SOLD_OUT'),
    popContent: i18n.global.t(
      'modules.checkout.SOME_PRODUCTS_SOLD_OUT_UPDATING_THE_ORDER'
    ),
    popBtn: i18n.global.t('modules.checkout.UPDATE_NOW'),
    tipText: i18n.global.t('modules.checkout.ORDER_HAS_BEEN_UPDATED')
  },
  allOutOfStock: {
    popTitle: i18n.global.t('modules.checkout.PRODUCTS_HAVE_BEEN_SOLD_OUT'),
    popContent: i18n.global.t('modules.checkout.LOOK_OTHER_ASIN'),
    popBtn: i18n.global.t('modules.checkout.I_UNDERSTAND')
  },
  invalidCoupon: {
    popTitle: i18n.global.t(
      'modules.checkout.SOME_DISCOUNTS_HAVE_BEEN_SOLD_OUT'
    ),
    popContent:
      i18n.global.t('modules.checkout.SOME_DISCOUNTS_HAVE_BEEN_SOLD_OUT') +
      i18n.global.t(
        'modules.checkout.UPDATING_ORDER_ALLOWS_YOU_CONTINUE_PLACING'
      ),
    popBtn: i18n.global.t('modules.checkout.UPDATE_NOW'),
    tipText: i18n.global.t('modules.checkout.ORDER_HAS_BEEN_UPDATED')
  },
  quantityLimit: {
    tipErrorText: i18n.global.t(
      'modules.checkout.PLEASE_CONFIRM_THE_PURCHASE_RESTRICTION'
    ),
    tipText: i18n.global.t(
      'modules.checkout.AUTOMATIC_PURCHASE_RESTRICTION_CONFIRMATION_SUCCESSFUL'
    )
  },
  unknownFail: {
    popTitle: i18n.global.t('modules.checkout.FAILED_TO_CREATE_THE_ORDER'),
    popBtn: i18n.global.t('modules.checkout.I_UNDERSTAND')
  },
  uninstallWechat: {
    popTitle: i18n.global.t('modules.checkout.WECHAT_NOT_INSTALLED'),
    popContent: i18n.global.t('modules.checkout.PLEASE_INSTALL_WECHAT_FIRST'),
    popBtn: i18n.global.t('modules.checkout.I_UNDERSTAND')
  },
  notPlaceOrder: {
    popBtn: i18n.global.t('modules.checkout.I_UNDERSTAND')
  }
};
export const handleAddressInfo = (value = {}) => {
  return {
    addressLine1: value?.address,
    addressLine2: '',
    addressLine3: '',
    addressStr: value?.street + value?.address,
    city: value?.city,
    country: constants.marketPlaceStyleMap[encryptedMarketplaceId],
    district: value?.district,
    postalCode: value?.postalCode,
    customerContact: value?.name + value?.phone,
    email: '',
    name: value?.name,
    phoneNumber: value?.phone,
    state: value?.state
  };
};
export function handleAssociateToken(associateToken, merchantId) {
  const merchantName = constants.MERCHANT_ID_TO_NAME_MAP[merchantId];
  if (merchantName && associateToken[merchantName]) {
    const originalAssociateInfo = associateToken[merchantName];
    return {
      assocToken: originalAssociateInfo.assocToken,
      associatedStore: originalAssociateInfo.attributionInfo.associatedStore,
      campaignCreativeMapId: originalAssociateInfo.attributionInfo.campaignId,
      clickToCartSeconds: originalAssociateInfo.tagClickToCartSeconds,
      creativeASIN: originalAssociateInfo.attributionInfo.creativeASIN,
      linkCode: originalAssociateInfo.attributionInfo.linkCode,
      tagID: originalAssociateInfo.attributionInfo.tagId,
      tagValue: originalAssociateInfo.attributionInfo.tagValue
    };
  }
  return false;
}
export const getIsPlaceOrder = async () => {
  const configData = await getAppConfig(
    constants.ENUM_APP_CONFIG_TYPE.SETTING_PAGE
  );
  const isPlaceOrder = configData?.appControl?.freezeRule?.placeOrder ?? false;
  const title = configData?.appControl?.title ?? '';
  const content = configData?.appControl?.content ?? '';
  return { isPlaceOrder, title, content };
};
